// Registers the service worker (src/service-worker.js) that makes the app
// installable from the browser. Production builds only: `npm start` has no
// service worker, so development always runs the code as it is on disk.
//
// A browser registers a service worker only on HTTPS or on localhost.

// How often an open app looks for a newer deploy. The browser also checks on
// every page load.
const UPDATE_CHECK_MS = 60 * 60 * 1000;

export function register() {
  if (process.env.NODE_ENV !== "production" || !("serviceWorker" in navigator)) {
    return;
  }
  const start = () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .then((registration) => {
        setInterval(() => {
          registration.update().catch(() => {});
        }, UPDATE_CHECK_MS);
      })
      .catch((error) => {
        // The app works the same without it - it only cannot be installed.
        console.error("Service worker registration failed:", error);
      });
  };
  // After the page has loaded, so registering never competes with the app's
  // own first requests.
  if (document.readyState === "complete") {
    start();
  } else {
    window.addEventListener("load", start);
  }
}
